import { PoolProcessingStatusCode } from 'Feature/V2/HbtMasterPool/components/HbtMasterPool/component/ForceStatusFlyout/types';
import { ValidationReviewFlyoutStatus } from 'Feature/V2/HbtMasterPool/components/HbtMasterPool/component/ForceStatusFlyout/Utils/utils';
import {
  REASON_FOR_FAILING_LOAN_CANCELLATION,
  REASON_FOR_FAILING_LOAN_NON_CANCELLATION,
  REASON_FOR_PASSING_LOAN_CANCELLATION,
  REASON_FOR_PASSING_LOAN_NON_CANCELLATION
} from 'Feature/V2/HbtMasterPool/constants';
import { LoanInventoryTableFields } from '../types';

export const getRemarksDropDown = (
  selectedRowsData: LoanInventoryTableFields[],
  pptCode: string | null
) => {
  const isFailedLoan = selectedRowsData[0]?.loanStatus === ValidationReviewFlyoutStatus.FAILED;
  const isCancellationLoan = pptCode === PoolProcessingStatusCode.CANCELLED;

  const ids = isCancellationLoan
    ? isFailedLoan
      ? REASON_FOR_FAILING_LOAN_CANCELLATION
      : REASON_FOR_PASSING_LOAN_CANCELLATION
    : isFailedLoan
      ? REASON_FOR_FAILING_LOAN_NON_CANCELLATION
      : REASON_FOR_PASSING_LOAN_NON_CANCELLATION;

  const remarksDropDownHeader = [
    {
      ids,
      groupName: ''
    }
  ];

  return { isCancellationLoan, remarksDropDownHeader };
};
